import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Avatar,
  Stack,
} from "@mui/material";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../core/context/ToolContext";
import { rqx } from "../../../core/request/API";
import { env } from "../../../core/Env";
import { ReconnectAccount } from "../reports/socialMediaInsight/insight/reconnectaccount/Index";
import { ProfilesAndPages } from "../reports/socialMediaInsight/insight/profilesandpages/Index";
import { SnakeLoader } from "../../../core/loader/SnakeLoader";
import DisconnectModal from "./modal/DisconnectModal";
import moment from "moment";

const FacebookSettings = () => {
  const { tool_state, social_media_insight_state } = useContext(ToolContext);
  const [loading, setLoading] = useState(false);
  const [followers, setFollowers] = useState(0);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);
  const [img, setImg] = useState("");
  const { userId, __SESSION } = tool_state;
  const FacebookAccountNotConnected =social_media_insight_state.accountNotConnected.data;
  // const FacebookAccountNotConnected = true;
  const facebookData = social_media_insight_state.facebookData.data;
  const [mainData, setMainData] = useState(null);
  const [settings, setSettings] = useState({
    auto_post_enabled: facebookData?.auto_post_enabled || 0,
    notify_on_success: facebookData?.notify_on_success || 0,
    notify_on_failure: facebookData?.notify_on_failure || 0,
    weekly_email_summary: facebookData?.weekly_email_summary || 0,
  });
  useEffect(() => {
    if (facebookData) {
      setSettings({
        auto_post_enabled: facebookData?.auto_post_enabled ?? 0,
        notify_on_success: facebookData?.notify_on_success ?? 0,
        notify_on_failure: facebookData?.notify_on_failure ?? 0,
        weekly_email_summary: facebookData?.weekly_email_summary ?? 0,
      });
    }
  }, [facebookData]);
  const PERMISSION_DESCRIPTIONS = {
    email: "Access your email address",
    read_insights: "Read insights and analytics",
    pages_show_list: "Access your page list",
    pages_read_engagement: "View engagement metrics",
    pages_read_user_content: "Read user content posted on your page",
    pages_manage_posts: "Post content to your page",
    public_profile: "Access your public profile information",
    pages_manage_metadata: "Manage page settings",
  };

  const url = new URL(window.location.href);

  // const facebookAuthUrl = process.env.REACT_APP_FACEBOOK_AUTH_URL || 'http://localhost:3000';
  const facebookAuthUrl = `https://www.facebook.com/v20.0/dialog/oauth?client_id=1010264311316196&redirect_uri=${process.env.REACT_APP_URL_TOOL_BIZ}/facebook/callback&state=facebook-settings&scope=email,read_insights,pages_show_list,pages_read_engagement,pages_read_user_content,pages_manage_posts&response_type=code`;

  const connectToPlatform = () => {
    console.log("connectToPlatform called !!!");
    console.log("facebookAuthUrl: ", facebookAuthUrl);
    window.open(facebookAuthUrl, "_self");
    console.log("Redirected !!!");
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const bdy = {
        user_id: userId.data,
        company_id: __SESSION.data.uaccess[0].company_id,
        platform: "1",
      };
      // console.log("bdy: ", bdy);

      const response = await rqx.get(
        `<<tool>>/${env()}/facebookInsights/social_account_details`,
        bdy
      );
      if (response?.message === 'error' && response?.needs_page_selection) {
        // Show page selection modal when no page is selected
        social_media_insight_state.accountNotConnected.set(false);
        social_media_insight_state.facebookData.set(response);
        
        // Fetch available pages and show selection modal
        const pagesResponse = await rqx.get(
          `<<tool>>/${env()}/facebookInsights/get_facebook_pages`,
          { user_id: userId.data }
        );
        
        if (pagesResponse?.message === 'success') {
          social_media_insight_state.profilePages.set(pagesResponse.data.available_pages || []);
          social_media_insight_state.showProfilesModal.set(true);
        }
        return;
      }
      if (response.data.active != 0 && !response?.data?.needs_page_selection) {
        social_media_insight_state.accountNotConnected.set(false);
        social_media_insight_state.facebookData.set(response.data);
        const pages = await rqx.fbGraph(
          "me/accounts",
          response?.data?.access_token,
          {}
        );
        const page = pages?.data?.find(
          (page) => page?.id === response?.data?.page_id
        );
        if (page) {
          social_media_insight_state.accessToken.set(page.access_token);
          social_media_insight_state.selectedProfileId.set(page.id);
          social_media_insight_state.urlCode.set("true");
          setMainData(page);
        }

        const followsResponse = await rqx.fbGraph(
          `${social_media_insight_state.selectedProfileId.data}/?fields=followers_count,picture.width(200).height(200)`,
          social_media_insight_state.accessToken.data
        );
        setFollowers(followsResponse.followers_count);
        setImg(followsResponse.picture.data.url);

        //data will be set here
        if (response.error || response.message === "error") {
          return;
        }
      } else {
        social_media_insight_state.accountNotConnected.set(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const url = new URL(window.location.href);
      let code = url.searchParams.get("code") || "";

      if (code) {
        try {
          social_media_insight_state.showProfilesModal.set(true);
          let bdy = {
            code: code,
            user_id: userId.data,
            company_id: __SESSION.data.uaccess[0].company_id,
          };
          social_media_insight_state.profilePagesLoading.set(true);
          const response = await rqx.post(
            `<<tool>>/${env()}/facebookInsights/connect_facebook_account`,
            bdy
          );

          if (response?.message === "success") {
            social_media_insight_state.profilePages.set(
              response?.data?.available_pages || []
            );
            social_media_insight_state.showProfilesModal.set(true);
            url.searchParams.delete("code");
            window.history.replaceState({}, "", url);
            // setTimeout(() => {
            //   social_media_insight_state.urlCode.set("true");
            // }, 100);
            social_media_insight_state.facebookData.set(response.data);
          } else {
            social_media_insight_state.showProfilesModal.set(false);
            console.error(
              "API response was not successful:",
              response?.details?.message
            );
          }
          // social_media_insight_state?.urlCode?.set(code);
        } catch (error) {
          console.log("closing for error");

          social_media_insight_state.showProfilesModal.set(false);
          console.error("Error connecting account:", error);
        } finally {
          social_media_insight_state.profilePagesLoading.set(false);
        }
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    // Check if OAuth callback is currently being processed
    const url = new URL(window.location.href);
    const isOAuthCallback = url.searchParams.get("code");

    // Only fetch data if OAuth callback is not being processed
    if (!isOAuthCallback) {
      fetchData();
    }
  }, [social_media_insight_state.urlCode.data]);

  const handleDisconnectClick = () => {
    setDisconnectModalOpen(true);
  };

  const disconnect = async () => {
    try {
      let bdy = {
        user_id: userId.data,
      };
      const response = await rqx.post(
        `<<tool>>/${env()}/facebookInsights/disconnect_facebook_account`,
        bdy
      );
      if (response?.message === "success") {
        social_media_insight_state.accountNotConnected.set(true);
        social_media_insight_state.connectedPlatform.set("");
        social_media_insight_state.selectedPlatform.set("");
        social_media_insight_state.profilePages.set([]);
        social_media_insight_state.selectedProfileId.set("");
        social_media_insight_state.accessToken.set("");
        social_media_insight_state.insightData.set(null);
        social_media_insight_state.topContentsData.set([]);
        fetchData();
        setDisconnectModalOpen(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDisconnecting(false);
    }
  };
  const redirectToAnalytics = () => {
    window.location.href = "/reports/social-media-insight?state=facebook";
  };
  const handleFacebookRedirect = () => {
    window.open(
      `https://www.facebook.com/${social_media_insight_state.selectedProfileId.data}`,
      "_blank"
    );
  };
  const handleSaveSettings = async () => {
    try {
      const body = {
        user_id: userId?.data,
        ...settings,
      };

      const res = await rqx.post(
        `<<tool>>/${env()}/autoPostToFacebook/update_facebook_account_settings`,
        body
      );

      if (res?.message === "success") {
        fetchData();
      }
    } catch (err) {
      console.error("Failed to update settings", err);
    }
  };
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: "#F8FAFC",
          minHeight: "100vh",
          padding: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "#F8FAFC",
        minHeight: "100vh",
        padding: "32px",
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Page Title */}
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#0F172A",
            marginBottom: "24px",
          }}
        >
          Facebook Integration Settings
        </Typography>
        <Box
          sx={{
            boxShadow: "0px 0px 4px 0px #0000001F",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          {!FacebookAccountNotConnected ? (
            <>
              {/* Facebook Page Connection Section */}
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  marginBottom: "20px",
                  paddingBottom: "20px",
                  borderBottom: "1px solid #C5C5C5",
                  lineHeight: "100%",
                }}
              >
                Facebook Page Connection
              </Typography>
              <Box
                sx={{
                  borderRadius: "12px",
                  marginBottom: "0",
                  overflow: "visible",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: "20px",
                  }}
                >
                  {/* Left Side - Green Gradient */}
                  <Box
                    sx={{
                      background:
                        "linear-gradient(90deg, #11793C 0%, #17CB63 100%)",
                      borderRadius: "12px",
                      padding: "16px",
                      flex: 1,
                      color: "#FFFFFF",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 70,
                          height: 70,
                          backgroundColor: img ? "transparent" : "#E4F3FF",
                          border: "1px solid #213391",
                        }}
                      >
                        {img ? (
                          <img
                            src={img}
                            alt={mainData?.name || "Facebook Page"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <PersonOutlineOutlinedIcon
                            sx={{
                              color: "#213391",
                              fontSize: "58px",
                            }}
                          />
                        )}
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "18px",
                              lineHeight: "100%",
                              marginBottom: "8px",
                            }}
                          >
                            {mainData?.name || "Your Page name"}
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "12px",
                              lineHeight: "100%",
                              marginBottom: "15px",
                            }}
                          >
                            @{facebookData?.username || "yourpage"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            gap: "14px",
                            marginTop: "16px",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <PeopleOutlineIcon sx={{ fontSize: "20px" }} />
                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: 500,
                                lineHeight: "100%",
                              }}
                            >
                              {followers}
                            </Typography>
                          </Box>

                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "100%",
                            }}
                          >
                            {facebookData?.location}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              lineHeight: "100%",
                            }}
                          >
                            Connected on:{" "}
                            {moment(facebookData?.connected_on).format(
                              " MMM DD, yyyy"
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      padding: "16px",
                      minWidth: "406px",
                      backgroundColor: "#F0F5F9",
                      borderRadius: "14px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: "15px",
                        pb: "15px",
                        borderBottom: !FacebookAccountNotConnected
                          ? "1px solid #C5C5C5"
                          : "none",
                      }}
                    >
                      <Typography sx={{ fontSize: "14px", color: "#898989" }}>
                        Connection Status:
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <CheckCircleOutlineIcon
                          sx={{ color: "#16A34A", fontSize: "18px" }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 500, // Medium
                            fontSize: "14px",
                            lineHeight: "100%",
                            letterSpacing: "0%",
                            textAlign: "right",
                          }}
                        >
                          Connected & Active
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 400, // Regular
                          fontSize: "14px",
                          lineHeight: "100%",
                          color: "#898989",
                        }}
                      >
                        Token Status:
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <CheckCircleOutlineIcon
                          sx={{ color: "#16A34A", fontSize: "18px" }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 500, // Medium
                            fontSize: "14px",
                            lineHeight: "100%",
                            letterSpacing: "0%",
                            textAlign: "right",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Valid &nbsp;{" "}
                          <Typography style={{ color: "#DC2626" }}>
                            (Expires in 58 days)
                          </Typography>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Page Details */}
                <Box
                  sx={{
                    padding: "10px",
                  }}
                >
                  <Box sx={{ padding: "10px" }}>
                    <Box
                      sx={{ display: "flex", gap: "32px", flexWrap: "wrap" }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: "14px", color: "#898989" }}>
                          Page ID:
                        </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                          {facebookData?.page_id || "XXXXXXXXX"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "14px", color: "#898989" }}>
                          Category:
                        </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                          {mainData?.category}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ padding: "10px", borderTop: "1px solid #C5C5C5" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "10px",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ color: "#16A34A", fontSize: "18px" }}
                    />
                    <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                      Active Permissions:
                    </Typography>
                  </Box>

                  <Stack spacing={1.5}>
                    {facebookData?.scopes?.split(",").map((permissionName) => {
                      const trimmedName = permissionName.trim();

                      return (
                        <Box
                          key={trimmedName}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <CheckCircleOutlineIcon
                            sx={{ color: "#16A34A", fontSize: "14px" }}
                          />
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            {trimmedName}
                          </Typography>
                          <Typography
                            sx={{ fontSize: "14px", color: "#898989" }}
                          >
                            -{" "}
                            {PERMISSION_DESCRIPTIONS[trimmedName] ||
                              "No description available"}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Stack>
                </Box>
                {/* Action Buttons */}
                <Box
                  sx={{
                    padding: "16px 10px",
                    borderTop: "1px solid #E2E8F0",
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#0098F6",
                      color: "#FFFFFF",
                      height: "36px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 500, // Bold
                      fontSize: "14px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textAlign: "center",

                      "&:hover": {
                        backgroundColor: "#0098F6",
                      },
                    }}
                  >
                    Refresh Token
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#7993B1",
                      color: "#FFFFFF",
                      height: "36px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 500, // Bold
                      fontSize: "14px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textAlign: "center",

                      "&:hover": {
                        backgroundColor: "#7993B1",
                      },
                    }}
                    onClick={redirectToAnalytics}
                  >
                    View Page Analytics
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleFacebookRedirect}
                    sx={{
                      backgroundColor: "#4896F0",
                      color: "#FFFFFF",
                      height: "36px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 500, // Bold
                      fontSize: "14px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textAlign: "center",
                      "&:hover": {
                        backgroundColor: "#4896F0",
                      },
                    }}
                  >
                    Open Facebook Page
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDisconnectClick}
                    sx={{
                      backgroundColor: "#FF6868",
                      color: "#FFFFFF",
                      height: "36px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontWeight: 500, // Bold
                      fontSize: "14px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textAlign: "center",
                      "&:hover": {
                        backgroundColor: "#FF6868",
                      },
                    }}
                  >
                    Disconnect
                  </Button>
                </Box>

                {/* Important Information Alert */}
                <Box
                  sx={{
                    margin: "10px 10px 0px 10px",
                    backgroundColor: "#FFF3CD",
                    border: "1px solid #FAC51C",
                    borderRadius: "8px",
                    padding: "10px",
                    display: "flex",
                    gap: "12px",
                    boxShadow: "0px 1px 4px 0px #00000040",
                    alignItems: "center",
                  }}
                >
                  <ReportProblemOutlinedIcon
                    sx={{ color: "#604900", fontSize: "38px" }}
                  />
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#604900",
                        marginBottom: "4px",
                      }}
                    >
                      Important Information
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#604900",
                      }}
                    >
                      Facebook access tokens expire every 60 days. You'll
                      receive a notification when it's time to refresh your
                      connection. If the token expires, scheduled posts will
                      fail until you reconnect.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                maxWidth: "820px",
                mx: "auto",
                p: { xs: 3, sm: 4 },
                my:"140px"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: 3,
                }}
              >
                {/* Title + icon */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.2,
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="#1877F2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2c0-2 1.2-3.1 3-3.1.9 0 1.8.1 2 .1v2.3h-1.1c-1 0-1.3.6-1.3 1.2v1.5h2.6l-.4 3h-2.2v7A10 10 0 0 0 22 12" />
                  </svg>

                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#212529",
                    }}
                  >
                    Facebook Account Not Connected
                  </Typography>
                </Box>

                {/* Description */}
                <Typography
                  sx={{
                    fontSize: "18px",
                    color: "#555",
                    maxWidth: "820px",
                    lineHeight: 1.6,
                  }}
                >
                  Connect your Facebook account to post promotions directly to
                  your Facebook Page, track post performance, and view Facebook
                  Page insights in the dashboard.
                </Typography>

                {/* CTA */}
                <Button
                  variant="contained"
                  onClick={connectToPlatform}
                  sx={{
                    backgroundColor: "#1877F2",
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: "10px",
                    px: 3,
                    py: 1.2,
                    "&:hover": {
                      backgroundColor: "#0f6ae6",
                    },
                  }}
                >
                  Connect to Facebook
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        {!FacebookAccountNotConnected && (
          <Box
            sx={{
              boxShadow: "0px 0px 4px 0px #0000001F",
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              padding: "20px",
            }}
          >
            {/* Auto-Post Settings */}
            <Typography
              sx={{
                marginBottom: "10px",
                fontSize: "18px",
                fontWeight: 600,
                paddingBottom: "10px",
                borderBottom: "1px solid #C5C5C5",
              }}
            >
              Auto-Post Settings
            </Typography>

            <Box>
              <Stack spacing={1.5}>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!settings.auto_post_enabled}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            auto_post_enabled: e.target.checked ? 1 : 0,
                          })
                        }
                        sx={{
                          color: "#106C36",
                          transform: "scale(0.8)",
                          "&.Mui-checked": {
                            color: "#106C36",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#0F172A",
                          }}
                        >
                          Auto-post new product and booking promotions
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                          Automatically post to Facebook when you publish a new
                          product and booking promo
                        </Typography>
                      </Box>
                    }
                  />
                </Box>

                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!settings.notify_on_success}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            notify_on_success: e.target.checked ? 1 : 0,
                          })
                        }
                        sx={{
                          color: "#106C36",
                          transform: "scale(0.8)",
                          "&.Mui-checked": {
                            color: "#106C36",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#0F172A",
                          }}
                        >
                          Notify on successful posts
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                          Receive notifications when posts are successfully
                          published
                        </Typography>
                      </Box>
                    }
                  />
                </Box>

                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!settings.notify_on_failure}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            notify_on_failure: e.target.checked ? 1 : 0,
                          })
                        }
                        sx={{
                          color: "#106C36",
                          transform: "scale(0.8)",
                          "&.Mui-checked": {
                            color: "#106C36",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#0F172A",
                          }}
                        >
                          Alert on failed posts
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                          Get email alerts when posts fail to publish
                        </Typography>
                      </Box>
                    }
                  />
                </Box>

                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!settings.weekly_email_summary}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            weekly_email_summary: e.target.checked ? 1 : 0,
                          })
                        }
                        sx={{
                          color: "#106C36",
                          transform: "scale(0.8)",
                          "&.Mui-checked": {
                            color: "#106C36",
                          },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#0F172A",
                          }}
                        >
                          Weekly performance summary
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
                          Receive weekly email with post performance metrics
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              </Stack>

              <Button
                variant="contained"
                onClick={handleSaveSettings}
                sx={{
                  marginTop: "24px",
                  backgroundColor: "#11783c",
                  color: "#FFFFFF",
                  height: "36px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 500,
                  paddingX: "24px",
                  "&:hover": {
                    backgroundColor: "#11783c",
                  },
                }}
              >
                Save Settings
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      {social_media_insight_state.showReconnectModal.data && (
        <ReconnectAccount onConnect={connectToPlatform} />
      )}

      {social_media_insight_state.showProfilesModal.data && (
        <ProfilesAndPages />
      )}
      <DisconnectModal
        open={disconnectModalOpen}
        onClose={() => setDisconnectModalOpen(false)}
        onDisconnect={disconnect}
        loading={disconnecting}
      />
    </Box>
  );
};

export default FacebookSettings;
